import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FormsModel, Option, Response, StaticMethods} from '../../../model/GeneralModels';
import {ListService} from '../../../services/list.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AppSettingsService} from '../../../services/app-settings.service';
import {IndividualAccidentsService} from '../../../services/individual-accidents.service';
import {GeneralService} from '../../../services/general.service';

@Component({
  selector: 'app-basic-information',
  templateUrl: './basic-information.component.html',
  styleUrls: [
    '../../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css',
  ]
})
export class BasicInformationComponent implements OnInit {
  productName = 'INDIVIDUAL_ACCIDENTS';
  forms: FormsModel[] = [];
  viewList: any = {};
  translation: any = {};

  constructor(private activatedRoute: ActivatedRoute,
              private generalService: GeneralService,
              private router: Router) {
  }

  ngOnInit(): void {
    this.generalService.getBasicInformationQuestions(this.productName, 0).subscribe(response => {
      if (response.success) {
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        console.log(this.translation);
        this.forms.push(new FormsModel(response.data, null));
      }
    });
  }

  checkCreationRequirement(cb) {
    this.generalService.checkCreationRequirement(this.productName, this.forms[0].formGroup.value).subscribe(response => {
      if (response.success) {
        cb(response.data);
      }
    }, error => {
      cb(false);
    });
  }

  goNext() {
    if (this.forms[0].formGroup.valid) {
      this.checkCreationRequirement((result) => {
        if (result) {
          this.router.navigate([`/individual-accidents/offers`],
            {
              state: {
                viewList: this.viewList,
                formsData: this.forms[0].formGroup.value,
                translation: this.translation
              }
            });
        }
      });
    } else {
      console.log(this.forms[0].formGroup);
    }
  }
}
